import balanceSure from '../../views/balance-msg/balance-sure.vue';
import balanceFail from '../../views/balance-msg/balance-fail.vue';
import balanceSuccess from '../../views/balance-msg/balance-success.vue';
import balanceAccountOverview from '../../views/balance-msg/balance-account-overview.vue';
import balanceDetail from '../../views/balance-msg/balance-detail.vue';
var balance = [
    {
        name: 'balanceSure',
        path: 'balance-sure',
        component: balanceSure,
    },
    {
        name: 'balanceFail',
        path: 'balance-fail',
        component: balanceFail,
    },
    {
        name: 'balanceSuccess',
        path: 'balance-success',
        component: balanceSuccess,
    },
    {
        name: 'balanceAccountOverview',
        path: 'balance-account-overview',
        component: balanceAccountOverview,
    },
    {
        name: 'balanceDetail',
        path: 'balance-detail',
        component: balanceDetail,
    },
];
export default balance;
